export default "__VITE_ASSET__BFpUEBP$__"